/* OPTIQ - scroll reveals, sticky header state, announcement rotation.
   Everything here is progressive enhancement: with JS off or reduced motion
   on, content is fully visible and the page still reads correctly. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* --- Scroll reveals ---------------------------------------------------
     One shared observer for the whole page. Elements unobserve after they
     reveal, so nothing keeps running once it has played. */
  function initReveals() {
    var items = $$('[data-o-reveal], .o-mask');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;

        // Stagger children of a group without needing per-element markup.
        var group = el.getAttribute('data-o-reveal-group');
        if (group) {
          $$('[data-o-reveal], .o-mask', el).forEach(function (child, i) {
            child.style.setProperty('--o-reveal-delay', (i * 70) + 'ms');
            child.classList.add('is-revealed');
          });
        }
        el.classList.add('is-revealed');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* --- Sticky header ----------------------------------------------------
     A single flag toggled from a rAF-throttled scroll listener. No layout
     reads happen per frame beyond one scrollY lookup. */
  function initHeader() {
    var header = $('[data-o-header]');
    if (!header) return;

    var ticking = false;
    var condensed = false;

    function update() {
      var should = (window.scrollY || window.pageYOffset) > 12;
      if (should !== condensed) {
        condensed = should;
        header.classList.toggle('is-condensed', should);
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();

    // Publish the real header height so :target offsets and sticky bars
    // can position against it instead of a hardcoded guess.
    function setHeight() {
      document.documentElement.style.setProperty('--o-header-h', header.offsetHeight + 'px');
    }
    setHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(header);
  }

  /* --- Announcement rotation -------------------------------------------
     Pauses on hover and on keyboard focus, and never runs for a single
     message or under reduced motion. */
  function initAnnouncement() {
    var bar = $('[data-o-announce]');
    if (!bar) return;

    var messages = $$('[data-o-announce-msg]', bar);
    if (messages.length < 2) return;

    var interval = parseInt(bar.getAttribute('data-o-announce-interval'), 10) || 5000;
    var index = 0;
    var timer = null;

    function show(next) {
      messages[index].classList.remove('is-active');
      messages[index].setAttribute('aria-hidden', 'true');
      index = (next + messages.length) % messages.length;
      messages[index].classList.add('is-active');
      messages[index].setAttribute('aria-hidden', 'false');
    }

    function start() {
      if (reduce || timer) return;
      timer = window.setInterval(function () { show(index + 1); }, interval);
    }
    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    var prev = $('[data-o-announce-prev]', bar);
    var next = $('[data-o-announce-next]', bar);
    if (prev) prev.addEventListener('click', function () { stop(); show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); show(index + 1); start(); });

    start();
  }

  function init() {
    initReveals();
    initHeader();
    initAnnouncement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
